const flexbasis = {
    name: "flex-basis",
    path: "/flex-basis",
    title: "flex-basis",
    description: "Utilities for controlling the initial size of flex items.",
    value: {
        "flex-basis": {
            "basis-<number>": "calc(var(--1) * <number>)",
            "basis-<fraction>": "<fraction>) * 100%",
            "basis-full": "100%",
            "basis-1/2": "50%",
            "basis-auto": "auto",
            "basis-1/3": "33.333333%",
            "basis-3xs": "var(--container-3xs)",
            "basis-2xs": "var(--container-2xs)",
            "basis-xs": "var(--container-xs)",
            "basis-sm": "var(--container-sm)",
            "basis-md": "var(--container-md)",
            "basis-lg": "var(--container-lg)",
            "basis-xl": "var(--container-xl)",
            "basis-2xl": "var(--container-2xl)",
            "basis-3xl": "var(--container-3xl)",
            "basis-4xl": "var(--container-4xl)",
            "basis-5xl": "var(--container-5xl)",
            "basis-6xl": "var(--container-6xl)",
            "basis-7xl": "var(--container-7xl)",
        }

    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="flex flex-row">
  <div class="basis-64">01</div>
  <div class="basis-64">02</div>
  <div class="basis-128">03</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="flex flex-row">
  <div class="basis-3xs">01</div>
  <div class="basis-2xs">02</div>
  <div class="basis-xs">03</div>
  <div class="basis-sm">04</div>
</div>
                `
            },
        },
        {
            "example": {
                "code": `
<div class="basis-[80vw] ...">
  <!-- ... -->
</div>
                `
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">basis-<number></code>
                  utilities like basis-64 and basis-128 to set the initial size of flex items based on the spacing scale:
            </p>

                <div class="flex flex-row space-x-4 font-mono text-sm leading-6 font-bold text-color-white">
                    <div class="flex h-14 basis-64 items-center justify-center rounded-lg bg-color-purple-500">01</div>
                    <div class="flex h-14 basis-64 items-center justify-center rounded-lg bg-color-purple-500">02</div>
                    <div class="flex h-14 basis-128 items-center justify-center rounded-lg bg-color-purple-500">03</div>
                </div>

            
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">basis-xs, basis-sm</code>
                  to set the initial size of flex items based on the container scale:
            </p>

            <div class="flex flex-row space-x-4 font-mono text-sm leading-6 font-bold text-color-white">
                <div class="flex h-14 basis-3xs items-center justify-center rounded-lg bg-color-sky-500">01</div>
                <div class="flex h-14 basis-2xs items-center justify-center rounded-lg bg-color-sky-500">02</div>
                <div class="flex h-14 basis-xs items-center justify-center rounded-lg bg-color-sky-500">03</div>
                <div class="flex h-14 basis-sm items-center justify-center rounded-lg bg-color-sky-500">04</div>
            </div>
        
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use the <code class="text-color-gray-800 dark:text-color-white font-semibold">basis-[<value>]</code>
                  syntax to set the basis based on a completely custom value:
            </p>

            <div class="flex flex-row space-x-4 font-mono text-sm leading-6 font-bold text-color-white">
                <div class="flex h-14 basis-full md:basis-2/3 items-center justify-center rounded-lg bg-color-sky-500">01</div>
                <div class="flex h-14 basis-[80vw] items-center justify-center rounded-lg bg-color-sky-500">02</div>  
          </div>
        
            `
        },
    ]
};

export default flexbasis;

<div className="sr-only">

<div class="flex flex-row space-x-4 font-mono text-sm leading-6 font-bold text-color-white">
                    <div class="flex h-14 basis-64 items-center justify-center rounded-lg bg-color-purple-500">01</div>
                    <div class="flex h-14 basis-64 items-center justify-center rounded-lg bg-color-purple-500">02</div>
                    <div class="flex h-14 basis-128 items-center justify-center rounded-lg bg-color-purple-500">03</div>
                </div>


                <div class="flex flex-row space-x-4 font-mono text-sm leading-6 font-bold text-color-white">
                <div class="flex h-14 basis-full md:basis-2/3 basis-[80vw] basis-[30%] basis-3xs basis-1/2 items-center justify-center rounded-lg bg-color-sky-500">01</div>
                <div class="flex h-14 basis-2xs items-center justify-center rounded-lg bg-color-sky-500">02</div>
                <div class="flex h-14 basis-xs items-center justify-center rounded-lg bg-color-sky-500">03</div>
                <div class="flex h-14 basis-sm items-center justify-center rounded-lg bg-color-sky-500">04</div>
            </div>

</div>